export default __webpack_public_path__ + "static/TeamEdHowskins-48af237740ef91b6eab18aaa0feab68f.png";